export default __webpack_public_path__ + "static/media/HEADERLOGOYARSI.f42e39d4.png";